import {
  Grid,
  Card,
  Dialog,
  DialogTitle,
  DialogContent,
  Slide,
} from "@material-ui/core";
import moment from "moment";
import "moment/locale/es";
import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  setActivosPorFecha,
  getConveniosPresupuestos,
  limpiarConveniosPresupuestos,
  //conveniosModificarPrespuesto,
} from "../../../actions/contrataciones/contratacionesConvenios";
import BuscadorConvenios from "./BuscadorConvenios";
import { TIPO_PRACTICAS_POR_FECHA } from "../../../utils/constants";
import { useReactToPrint } from "react-to-print";
import TableGeneric from "../../compartidos/abms/TableGeneric";
// import { useHistory } from "react-router-dom";
//import EditPresupuestoButton from "./EditPresupuestoButton";
import Info from "./Info";
import { Notes } from "@material-ui/icons";
import { setPresupuestoSeleccionado } from "../../../actions/autorizaciones/Autorizaciones";
import { NotasMenuPresupuesto } from "../../autorizaciones/gestionPresupuestos/Menus/NotasMenuPresupuesto";
import { ModalHistorialCambios } from "../../autorizaciones/gestionAuditoria/ModalHistorialCambios";
//import AddButtonAbm from "../../compartidos/abms/AddButtonAbm";
//import FormPresupuestosSinAutorizaciones from "./FormPresupuestosSinAutorizaciones";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export const ConveniosPresupuestos = (props) => {
  moment.locale("es");
  const dispatch = useDispatch();
  // const history = useHistory();

  const { dataContrato } = useSelector((state) => state.contrataciones);
  const { presupuestos } = useSelector((state) => state.contratacionesConvenios);

  //const [open, setOpen] = useState(false);
  const [presu, setPresu] = useState(null);
  const [openModalHistorialCambios, setOpenModalHistorialCambios] = useState(false);
  const [showModalNotas, setShowModalNotas] = useState(false);

  const componentRef = React.useRef();

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  /*
  const submitHandler = (data) => {
    const newData = {
      ...data,
      fechaFinVigencia: data.fechaFinVigencia,
      idPresupuesto: presupuesto.idPresupuesto
    };
    dispatch(conveniosCargarPrespuesto(newData, () => {
      setOpen(false);
      dispatch(setearPresupuestoContratos(null));
      // history.replace("/autorizaciones", null)
    }));
  }

  const submitHandlerButtonAdd = (data, handleClose) => {
    dispatch(conveniosCargarPrespuesto(data, handleClose));
  };
  
  const handleEditPresupuesto = (idItem, setOpen, data) => {
    dispatch(conveniosModificarPrespuesto(idItem, setOpen, data));
  };

  const handleClose = () => {
    dispatch(setearPresupuestoContratos(null));
    setOpen(false);
  };

  */

  const handleGetPracticas = (tipoDataPorFecha) => {
    dispatch(getConveniosPresupuestos(dataContrato?.idEfectorFacturacion, tipoDataPorFecha));
  };

  useEffect(() => {
      dispatch(setActivosPorFecha(TIPO_PRACTICAS_POR_FECHA.VIGENTES))
      dispatch(limpiarConveniosPresupuestos());
  }, []);

  if (presupuestos.length > 0) {
    presupuestos.sort((a, b) => new Date(a.fechaInicioVigencia) - new Date(b.fechaInicioVigencia));
  }

  return (
    <React.Fragment>
      {showModalNotas && (
        <Dialog
          open={showModalNotas}
          onClose={() => setShowModalNotas(false)}
          fullWidth
          maxWidth="sm"
          TransitionComponent={Transition}
          keepMounted
        >
          <DialogTitle>Notas</DialogTitle>
          <DialogContent>
            <NotasMenuPresupuesto
              showBotonAgregar={false}
              desdeIngresoSolicitud={false}
              disabled={true} />
          </DialogContent>
        </Dialog>
      )}
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Grid container spacing={1} >
            <Grid item xs={12}>
              {openModalHistorialCambios && (
                <ModalHistorialCambios
                  open={openModalHistorialCambios}
                  closeModalHandler={() => {
                    setOpenModalHistorialCambios(false);
                  }}
                  presupuesto={presu}
                  openPresupuesto
                  titulo={`Presupuesto N° ${presu.idPresupuesto}`}
                />
              )}
            </Grid>
            {/*<Grid item xs={12}>
              <AddButtonAbm
                title="Cargar Presupuesto"
                form={FormPresupuestosSinAutorizaciones}
                handleSave={submitHandlerButtonAdd}
                permiso={null}
                style={{ float: "right" }}
              />
            </Grid>*/}
            <Grid item xs={12}>
              <BuscadorConvenios
                disabled
                handleSearch={handleGetPracticas}
                handlePrint={handlePrint} />
            </Grid>
            <Grid item xs={12}>
              <Card style={{ overflowX: "auto", width: "100%" }}>
                <TableGeneric
                  ref={componentRef}
                  data={presupuestos}
                  align="left"
                  columns={[
                    {
                      label: "",
                      customBody: (item) => {
                        setPresu(item)
                        return (
                          <Info onClick={() => {
                            setOpenModalHistorialCambios(true);
                          }} />
                        )
                      }
                    },
                    {
                      label: "ID",
                      id: "idPresupuesto",
                      sort: true
                    },
                    {
                      label: "Estado",
                      id: "estadoPresupuesto.descripcion",
                      sort: true
                    },
                    {
                      label: "Prácticas",
                      customBody: (item) => (
                        <ul>
                          {
                            item.practicas.map(e => <li key={e.idCodNom}>{e.practica?.codNom} - {e.practica?.desNom}</li>)
                          }
                        </ul>
                      ),
                    },
                    {
                      label: "Valor",
                      id: "valor",
                      sort: true,
                      customBody: (item) => `$${item.valor}`,
                    },
                    {
                      label: "Fecha Inicio Vigencia",
                      id: "fecha",
                      sort: true,
                      customBody: (item) => moment(item.fecha).format("DD/MM/YYYY")
                    },
                    {
                      label: "Fecha Fin Vigencia",
                      id: "fechaVencimiento",
                      sort: true,
                      customBody: (item) => moment(item.fechaVencimiento).format("DD/MM/YYYY"),
                    },
                    {
                      label: "Afiliado",
                      id: "afiliado.apellido_y_nombre",
                      customBody: (item) => `${item.afiliado.apellido_y_nombre}\n ${item.afiliado.carnet}`
                    },
                    {
                      label: "Notas",
                      id: "",
                      customBody: (item) =>
                        <Notes
                          onClick={() => {
                            dispatch(setPresupuestoSeleccionado(item));
                            setShowModalNotas(true);
                          }}
                        />
                    },
                    /*{
                      label: "",
                      id: "",
                      customBody: (item) =>
                        <EditPresupuestoButton
                          idItem={item.idPresupuesto}
                          item={item}
                          editItem={handleEditPresupuesto}
                        />
                    }*/
                  ]}
                />
              </Card>
            </Grid>
          </Grid >
        </Grid >
      </Grid >
    </React.Fragment >
  );
};
